import { render } from "./Category.vue?vue&type=template&id=13f2db69"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Samsung\\Desktop\\PROYECTO__FINAL\\proyecto en git-hub\\Proyecto_ciclo3_pagina_web- H\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__